import config from '@/utils/config'
export default [
  {
    path: '/ayuda/manual-usuario',
    beforeEnter() {
      window.open(config.urlUserManual, '_blank')
    }
  },
  {
    path: '/ayuda/video',
    beforeEnter() {
      window.open(config.urlVideoTutorial, '_blank')
    }
  },
  {
    path: '/ayuda/support',
    component: () => import('@/views/help/Support.vue')
  },
  {
    path: '/ayuda/acercade',
    component: () => import('@/components/help/version.vue')
  },
  {
    path: '/ayuda/sef-ticketbai-data',
    component: () => import('@/views/help/SefTicketbaiData.vue')
  }
]
